import { DateRangePicker, DateRangePickerProps } from '@cloudscape-design/components';
import { addDays, addMonths, addWeeks, addYears, endOfMonth, endOfWeek, endOfYear, format, parse, startOfMonth, startOfWeek, startOfYear } from 'date-fns';
import React, { useEffect, useState } from 'react';
import { normalizeDate } from '../pages/commons/functions';
interface DRPickerModalModalProps {
    start?: string;
    end?: string;
    clear?: boolean;
    onConfirm: (startDate: string, endDate: string) => void;
}
const DRPickerModal: React.FC<DRPickerModalModalProps> = ({
    start = format(new Date(), 'dd-MM-yyyy'),
    end = format(new Date(), 'dd-MM-yyyy'),
    clear = true,
    onConfirm,
}) => {
    const [startDate, setStartDate] = useState<string>('');
    const [endDate, setEndDate] = useState<string>('');
    const [date, setDate] = React.useState<DateRangePickerProps.Value | null>({ type: "absolute", startDate: format(parse(start, "dd-MM-yyyy", new Date()), "yyyy/MM/dd"), endDate: format(parse(end, "dd-MM-yyyy", new Date()), "yyyy/MM/dd") });


    useEffect(() => {
        if (start && end && start !== "" || end !== "") {

            setDate({
                type: "absolute",
                startDate: format(parse(start, "dd-MM-yyyy", new Date()), "yyyy-MM-dd"),
                endDate: format(parse(end, "dd-MM-yyyy", new Date()), "yyyy-MM-dd"),
            })
        }
    }, [start, end]);

    const handleSelectAbsolute = (data: DateRangePickerProps.AbsoluteValue) => {
        console.log(data)
        console.log(format(data.startDate, "dd-MM-yyyy"))
        console.log("----------------")
        setStartDate(normalizeDate(data.startDate))
        setEndDate(normalizeDate(data.endDate))
        onConfirm(normalizeDate(data.startDate), normalizeDate(data.endDate))
        setDate({
            type: "absolute",
            startDate: format(data.startDate, "yyyy/MM/dd"),
            endDate: format(data.endDate, "yyyy/MM/dd"),
        })
    }
    const handleSelectRelative = (data: DateRangePickerProps.RelativeValue) => {
        const today = new Date();
        let start = "", end = ""
        if (data.type = "relative") {
            switch (data.key) {
                /*
                                { key: "today", amount: 10, unit: "day", type: "relative", },
                                { key: "yesterday", amount: 11, unit: "day", type: "relative", },
                                { key: "thisweek", amount: 1, unit: "day", type: "relative", },
                                { key: "pastweek", amount: 2, unit: "day", type: "relative", },
                                { key: "thismonth", amount: 3, unit: "day", type: "relative", },
                                { key: "previousmonth", amount: 4, unit: "day", type: "relative", },
                                { key: "last3months", amount: 5, unit: "day", type: "relative", },
                                { key: "last6months", amount: 6, unit: "day", type: "relative", },
                                { key: "thisyear", amount: 7, unit: "day", type: "relative", },
                                { key: "1year", amount: 8, unit: "day", type: "relative", },
                */
                case "today":
                    start = (format(today, 'dd-MM-yyyy'));
                    end = (format(today, 'dd-MM-yyyy'));
                    break;
                case "yesterday":
                    start = (format(addDays(today, -1), 'dd-MM-yyyy'));
                    end = (format(addDays(today, -1), 'dd-MM-yyyy'));
                    break;
                case "thisweek":
                    start = (format(startOfWeek(today, { weekStartsOn: 1 }), 'dd-MM-yyyy'));
                    end = (format(endOfWeek(today, { weekStartsOn: 1 }), 'dd-MM-yyyy'));
                    break;
                case "pastweek":
                    start = (format(addWeeks(startOfWeek(today, { weekStartsOn: 1 }), -1), 'dd-MM-yyyy'));
                    end = (format(addDays(startOfWeek(today, { weekStartsOn: 1 }), -1), 'dd-MM-yyyy'));
                    break;
                case "thismonth":
                    start = (format(startOfMonth(today), 'dd-MM-yyyy'));
                    end = (format(endOfMonth(today), 'dd-MM-yyyy'));
                    break;
                case "previousmonth":
                    start = (format(startOfMonth(addMonths(today, -1)), 'dd-MM-yyyy'));
                    end = (format(addDays(endOfMonth(addMonths(today, -1)), 0), 'dd-MM-yyyy'));
                    break;
                case "last3months":
                    end = (format(addDays(today, 0), 'dd-MM-yyyy'));
                    start = (format(addMonths(today, -3), 'dd-MM-yyyy'));
                    break;
                case "last6months":
                    end = (format(addDays(today, 0), 'dd-MM-yyyy'));
                    start = (format(addMonths(today, -6), 'dd-MM-yyyy'));
                    break;
                case "thisyear":
                    start = (format(startOfYear(today), 'dd-MM-yyyy'));
                    end = (format(today, 'dd-MM-yyyy'));
                    break;
                case "lastyear":
                    start = (format(startOfYear(addYears(today, -1)), 'dd-MM-yyyy'));
                    end = (format(endOfYear(addYears(today, -1)), 'dd-MM-yyyy'));
                    break;
                case "last2years":
                    start = (format(startOfYear(addYears(today, -2)), 'dd-MM-yyyy'));
                    end = (format(endOfYear(addYears(today, -2)), 'dd-MM-yyyy'));
                    break;
                case "1year":
                    start = (format(addYears(today, -1), 'dd-MM-yyyy'));
                    end = (format(today, 'dd-MM-yyyy'));
                    break;
                case "2years":
                    start = (format(addYears(today, -2), 'dd-MM-yyyy'));
                    end = (format(today, 'dd-MM-yyyy'));
                    break;
                case "3years":
                    start = (format(addYears(today, -3), 'dd-MM-yyyy'));
                    end = (format(today, 'dd-MM-yyyy'));
                    break;

            }

        }

        setStartDate(start)
        setEndDate(end)

        setDate({
            type: "absolute",
            startDate: format(parse(start, "dd-MM-yyyy", new Date()), "yyyy/MM/dd"),
            endDate: format(parse(end, "dd-MM-yyyy", new Date()), "yyyy/MM/dd"),
        })
        onConfirm(start, end);
    }


    return (
        <div style={{ minWidth: "230px" }}>
            <DateRangePicker
                hideTimeOffset
                onChange={({ detail }) => {
                    console.log(detail)
                    console.log(detail.value)
                    if (detail.value === null) {
                        setStartDate("")
                        setEndDate("")
                        setDate(null)
                        onConfirm("", "");
                    }
                    if (detail) {
                        if (!detail.value) {
                            setDate(null)
                            onConfirm("", "");
                        }
                        if (detail.value?.type === "relative" && detail.value.unit === "second") {
                            handleSelectRelative(detail.value)
                        } else if (detail.value?.type === "relative") {
                            let start = (format(new Date(), 'dd-MM-yyyy'));
                            let end = (format(new Date(), 'dd-MM-yyyy'));
                            if (detail.value?.unit === "day") {
                                start = (format(addDays(new Date(), -detail.value.amount), 'dd-MM-yyyy'));
                            } else if (detail.value?.unit === "week") {
                                start = (format(addWeeks(new Date(), -detail.value.amount), 'dd-MM-yyyy'));
                            } else if (detail.value?.unit === "month") {
                                start = (format(addMonths(new Date(), -detail.value.amount), 'dd-MM-yyyy'));
                            } else if (detail.value?.unit === "year") {
                                start = (format(addYears(new Date(), -detail.value.amount), 'dd-MM-yyyy'));

                            }


                            setStartDate(start)
                            setEndDate(end)

                            setDate({
                                type: "absolute",
                                startDate: format(parse(start, "dd-MM-yyyy", new Date()), "yyyy/MM/dd"),
                                endDate: format(parse(end, "dd-MM-yyyy", new Date()), "yyyy/MM/dd"),
                            })
                            onConfirm(start, end);

                        }

                    }
                    if (detail.value?.type === "absolute") {
                        handleSelectAbsolute(detail.value)
                    }
                }
                }
                value={date}
                relativeOptions={[
                    { key: "today", amount: 10, unit: "second", type: "relative", },
                    { key: "yesterday", amount: 11, unit: "second", type: "relative", },
                    { key: "thisweek", amount: 1, unit: "second", type: "relative", },
                    { key: "pastweek", amount: 2, unit: "second", type: "relative", },
                    { key: "thismonth", amount: 3, unit: "second", type: "relative", },
                    { key: "previousmonth", amount: 4, unit: "second", type: "relative", },
                    { key: "last3months", amount: 5, unit: "second", type: "relative", },
                    { key: "last6months", amount: 6, unit: "second", type: "relative", },
                    { key: "thisyear", amount: 7, unit: "second", type: "relative", },
                    { key: "lastyear", amount: 7, unit: "second", type: "relative", },
                    { key: "last2years", amount: 7, unit: "second", type: "relative", },
                    { key: "1year", amount: 8, unit: "second", type: "relative", },
                    { key: "2years", amount: 8, unit: "second", type: "relative", },
                    { key: "3years", amount: 8, unit: "second", type: "relative", },

                ]}
                isValidRange={range => {
                    console.log(range)
                    if (range && range.type === "absolute") {
                        const [
                            startDateWithoutTime
                        ] = range.startDate.split("T");
                        const [
                            endDateWithoutTime
                        ] = range.endDate.split("T");
                        if (
                            !startDateWithoutTime ||
                            !endDateWithoutTime
                        ) {
                            return {
                                valid: false,
                                errorMessage:
                                    "El rango es inválido. Seleccione inicio y término para el rango de fechas."
                            };
                        }
                        if (range && range.startDate && range.endDate) {
                            if (new Date(range.startDate).getTime() - new Date(range.endDate).getTime() > 0) {
                                return {
                                    valid: false,
                                    errorMessage:
                                        "El rango es inválido. Inicio debe ser anterior al término."
                                };
                            }
                        }
                    }

                    console.log(range)
                    return { valid: true };
                }}
                locale='es-CL'
                i18nStrings={{
                    absoluteModeTitle: "Absoluto",
                    applyButtonLabel: "Seleccionar",
                    cancelButtonLabel: "Cancelar",
                    relativeModeTitle: "Relativo",
                    todayAriaLabel: "Hoy",
                    customRelativeRangeDurationLabel: "Duración",
                    customRelativeRangeDurationPlaceholder: "Ingrese duración",
                    customRelativeRangeOptionDescription: "Rango customizado",
                    customRelativeRangeOptionLabel: "Manual",
                    customRelativeRangeUnitLabel: "Intervalo",
                    clearButtonLabel: "Borrar",
                    /*
                    
                                    { key: "today", amount: 10, unit: "day", type: "relative", },
                                    { key: "yesterday", amount: 11, unit: "day", type: "relative", },
                                    { key: "thisweek", amount: 1, unit: "day", type: "relative", },
                                    { key: "pastweek", amount: 2, unit: "day", type: "relative", },
                                    { key: "thismonth", amount: 3, unit: "day", type: "relative", },
                                    { key: "previousmonth", amount: 4, unit: "day", type: "relative", },
                                    { key: "last3months", amount: 5, unit: "day", type: "relative", },
                                    { key: "last6months", amount: 6, unit: "day", type: "relative", },
                                    { key: "thisyear", amount: 7, unit: "day", type: "relative", },
                                    { key: "1year", amount: 8, unit: "day", type: "relative", },*/

                    formatRelativeRange: (range) => {
                        if (range.key === "today") return "Hoy";
                        if (range.key === "yesterday") return "Ayer";
                        if (range.key === "thisweek") return "Esta semana";
                        if (range.key === "pastweek") return "Semana pasada";
                        if (range.key === "thismonth") return "Este mes";
                        if (range.key === "previousmonth") return "Mes pasado";
                        if (range.key === "last3months") return "Últ 3 meses";
                        if (range.key === "last6months") return "Últ 6 meses";
                        if (range.key === "thisyear") return "Este año";
                        if (range.key === "lastyear") return "Año pasado";
                        if (range.key === "last2years") return "Año antepasado";
                        if (range.key === "1year") return "1 año";
                        if (range.key === "2years") return "2 años";
                        if (range.key === "3years") return "3 años";
                        return ``;
                    },
                }}
                dateOnly
                startOfWeek={1}
                showClearButton={clear}
                placeholder="Seleccionar rango"
            />
        </div>
    );
};
export default DRPickerModal;